import { Box, TextField, Typography, useTheme } from "@mui/material"
import { BlackDownloadIcon, SearchIcon } from "../../../assets/SvgIcons"
import CustomTable from "../../investorOverview/common/customTable"
import { AmcTableBody, AmctableHeaderData, InvestorLevelAmcTableBody, InvestorLevelAmctableHeaderData } from "../../investorOverview/mutualFund/common/Table"
import { Order, SortingObj } from "../../investorOverview/types"

type InvestorLevelAMCProps = {
    title: string
    tableData: any
    isLoading: boolean
    filters?: boolean
    handleTableSorting: (orderBy: string, order: Order) => void
    sortingObj: SortingObj,
    setSortingObj: ({ order, orderBy }: SortingObj) => void
}


export default function InvestorLevelAMCPerformanceAnalysis(props: InvestorLevelAMCProps): JSX.Element {
    const { title, tableData, isLoading, filters = true, handleTableSorting, sortingObj, setSortingObj } = props
    const { palette, typography } = useTheme()


    return (
        <Box sx={{
            padding: '25px 30px 45px 30px',
            background: palette.common.white,
            borderRadius: '20px'
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h2" color={palette.text.primary}>
                    {title}
                </Typography>
                {filters && (
                    <Box display={'flex'} gap={'10px'}>
                        <Box component={'button'} sx={{ cursor: 'pointer', border: 'none', display: 'flex', gap: '10px', background: 'transparent', alignItems: 'center' }}>
                            <BlackDownloadIcon />
                            <Typography color={palette.text.primary} sx={{ ...typography.body_500 }}>Download</Typography>
                        </Box>
                        <Box component={'div'}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: '10px',
                                alignItems: 'center',
                                padding: '10px',
                                border: `1px solid ${palette.text.secondary}B2`,
                                borderRadius: '50px'
                            }}>
                            <SearchIcon />
                            <TextField
                                InputProps={{ disableUnderline: true }}
                                placeholder='Search'
                                variant='standard'
                            />
                        </Box>
                    </Box>

                )}

            </Box>
            <Box mt={'20px'}>
                <CustomTable
                    loadingRowsNum={5}
                    isLoading={isLoading}
                    tableBody={
                        <InvestorLevelAmcTableBody
                            tableBodyData={tableData || []}
                            handleCheckboxClick={(id: number) => console.log("Checkbox clicked", id)}
                        />
                    }
                    tableData={tableData || []}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },
                    }}
                    tableHeaderData={InvestorLevelAmctableHeaderData}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px"
                        }
                    }}
                    handleSort={handleTableSorting}
                    tableBodyCustomStyles={{
                        '& tr:last-child td': {
                            border: 0
                        }
                    }}
                    order={sortingObj.order}
                    orderBy={sortingObj.orderBy}
                    tableDataCount={tableData?.length || 0}
                    isPaginationVisible={false}
                />
            </Box>
        </Box>
    )
}